import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Colors from "../../../constants/Colors";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";

import NoteIcon from "@material-ui/icons/Assignment";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import {
  changeField,
  modifyManagerSurveyRequest,
  deleteManagerSurveyRequest
} from "../../../services/manager/actions";
import moment from "moment";
import SectionTitle from "./SectionTitle";
import { romanize } from "../../../utils/romanize";
import { Input, TextField } from "@material-ui/core";
import { LottieEmpty, Loader } from "../../../components/";
import { timingSafeEqual } from "crypto";

moment.locale("fr");

const LEFT_ARROW_KEY = 37;
const RIGHT_ARROW_KEY = 39;

const styles = theme => ({
  closeButton: {
    zIndex: 10,
    position: "absolute",
    top: 1,
    right: 1
  },
  modal: {
    display: "flex",
    overflow: "auto",
    height: "calc(100% - 20px)",
    maxWidth: 2000,
    width: "calc(75%)"
  },
  minDiv: {},
  accent: {
    color: "#6198DE"
  },
  commentDiv: {
    width: "100%",
    borderRadius: 8,
    border: "solid",
    borderWidth: 1,
    borderColor: Colors.lightGrey,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 15
  },
  date: {
    textAlign: "right",
    fontSize: 12
  },
  commentMainDiv: {
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  actionsButtonDiv: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  deleteButton: {
    position: "absolute",
    left: 1,
    top: 1,
    zIndex: 10
  },
  editButton: {
    padding: 1,
    marginRight: -3
  },
  commentBottom: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    display: "flex"
  },
  leftBorder: {
    zIndex: 5,
    marginLeft: 15,
    marginRight: 15,
    // paddingBottom: "2vh",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  rightBorder: {
    zIndex: 5,
    marginLeft: 15,
    marginRight: 15,
    // paddingBottom: "2vh",
    height: "100%",
    right: 0,
    // position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  chevronButton: {
    color: Colors.grey,
    backgroundColor: Colors.mediumGrey,
    zIndex: 5,
    "&:hover": {
      color: "#fff",
      backgroundColor: Colors.blackGrey
    }
  },
  question: {
    width: "100%",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    color: Colors.text,
    letterSpacing: "0.0075em",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex",
    fontWeight: "bold"
  },
  bottomDiv: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  },
  invisible: {
    visibility: "hidden"
  },
  title: {
    alignSelf: "center"
  },
  saveButtonDiv: {
    marginTop: -10,
    paddingBottom: 10,
    alignSelf: "center"
    // width: "100%"
  },
  middleContent: {
    height: "100%",
    paddingLeft: 2,
    paddingRight: 2
  },
  underline: {
    borderColor: Colors.main,
    "&:after": {
      // The MUI source seems to use this but it doesn't work
      borderBottom: `2px solid ${Colors.main}`
    }
  },
  additionalNotesInput: {
    // marginBottom: "1em",
    marginTop: "1em"
  },
  questionDiv: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  sign: {
    alignItems: "center",
    MozBoxSizing: "border-box",
    boxSizing: "border-box",
    display: "inline-flex",
    height: "25px",
    justifyContent: "center",
    width: "25px",
    background: "#fff",
    border: "1px solid #b7bfc6",
    borderRadius: "50%",
    color: "#848f99",
    fill: "#848f99",
    // color: "#b7bfc6",
    transition:
      "200ms box-shadow,200ms color,200ms background,200ms fill,200ms border-color",
    margin: "0 10px 0 0",
    "&:hover": {
      backgroundColor: "#e2fffa",
      borderColor: "#25e8c8",
      color: "#25e8c8",
      fill: "#25e8c8",
      cursor: "pointer"
    }
  },
  actionsDiv: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  }
});

class NotesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      surveyNumber: 0
    };
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown, false);
  }

  _handleKeyDown = event => {
    if (
      (window.navigator.platform.match("Mac")
        ? event.metaKey
        : event.ctrlKey) &&
      event.keyCode == 83
    ) {
      event.preventDefault();
      this.onSaveManagerSurvey();
    } else {
      switch (event.keyCode) {
        case LEFT_ARROW_KEY:
          if (this.props.selectedManagerNoteIndex > 0) {
            this.onPrevious();
          }
          break;
        case RIGHT_ARROW_KEY:
          if (
            this.props.selectedManagerNoteIndex <
            this.props.managerSurveys.length - 1
          ) {
            this.onNext();
          }
          break;
        default:
      }
    }
  };

  handleClose = onClose => () => {
    console.log("REMOVE");
    document.removeEventListener("keydown", this._handleKeyDown, false);
    onClose();
  };

  onRendered = () => {
    console.log("ADDD");
    document.addEventListener("keydown", this._handleKeyDown, false);
  };

  formatDate = date => {
    return moment(date).format("L");
  };

  onDelete = () => {
    this.setState({ open: true });
  };

  onEdit = () => {
    console.log("helloo");
  };

  closeDeleteModal = () => {
    this.setState({ open: false });
  };

  onPrevious = () => {
    this.props.changeField({
      selectedManagerNoteIndex: this.props.selectedManagerNoteIndex - 1
    });
  };

  onNext = () => {
    this.props.changeField({
      selectedManagerNoteIndex: this.props.selectedManagerNoteIndex + 1
    });
  };

  deleteComment = () => {
    this.props.deleteManagerCommentRequest({ commentId: this.state.commentId });
    this.setState({ open: false });
  };

  deleteSurvey = () => {
    this.props.deleteManagerSurveyRequest({
      surveyId: this.props.managerSurveys[this.props.selectedManagerNoteIndex]
        ._id
    });
    this.closeDeleteModal();
  };

  onChangeFundamentalQuestionInput = questionIndex => e => {
    const answer = e.target.value;

    const newManagerSurvey = {
      ...this.props.managerSurveys[this.props.selectedManagerNoteIndex]
    };
    newManagerSurvey.fundamentalSurvey.questions[questionIndex].answer = answer;

    // update current survey if it's the current one
    if (
      this.props.managerSurveys[this.props.selectedManagerNoteIndex]._id ===
      this.props.managerSurvey._id
    ) {
      this.props.changeField({
        managerSurvey: newManagerSurvey
      });
    }

    const managerSurveys = this.props.managerSurveys.map((el, i) => {
      if (this.props.selectedManagerNoteIndex === i) {
        return newManagerSurvey;
      }
      return el;
    });
    this.props.changeField({
      managerSurveys
    });
  };

  onChangeQuestionInput = (sectionIndex, questionIndex) => e => {
    const answer = e.target.value;

    const newManagerSurvey = {
      ...this.props.managerSurveys[this.props.selectedManagerNoteIndex]
    };
    newManagerSurvey.survey[sectionIndex].questions[
      questionIndex
    ].answer = answer;

    if (
      this.props.managerSurveys[this.props.selectedManagerNoteIndex]._id ===
      this.props.managerSurvey._id
    ) {
      this.props.changeField({
        managerSurvey: newManagerSurvey
      });
    }

    const managerSurveys = this.props.managerSurveys.map((el, i) => {
      if (this.props.selectedManagerNoteIndex === i) {
        return newManagerSurvey;
      }
      return el;
    });
    this.props.changeField({
      managerSurveys
    });
  };

  onChangeAdditionalNotes = e => {
    const notes = e.target.value;
    if (
      this.props.managerSurveys[this.props.selectedManagerNoteIndex]._id ===
      this.props.managerSurvey._id
    ) {
      this.props.changeField({
        managerSurvey: { ...this.props.managerSurvey, additionalNotes: notes }
      });
    }
    const newManagerSurvey = {
      ...this.props.managerSurveys[this.props.selectedManagerNoteIndex]
    };
    newManagerSurvey.additionalNotes = notes;
    const managerSurveys = this.props.managerSurveys.map((el, i) => {
      if (this.props.selectedManagerNoteIndex === i) {
        return newManagerSurvey;
      }
      return el;
    });
    this.props.changeField({
      managerSurveys
    });
  };

  onSaveManagerSurvey = () => {
    this.props.modifyManagerSurveyRequest({
      surveyId: this.props.managerSurveys[this.props.selectedManagerNoteIndex]
        ._id,
      survey: this.props.managerSurveys[this.props.selectedManagerNoteIndex]
    });
  };

  displayFundamentalSurvey = managerSurvey => {
    const { classes } = this.props;
    if (!managerSurvey.fundamentalSurvey) {
      return null;
    }
    return managerSurvey.fundamentalSurvey.questions.map(
      (el, questionIndex) => {
        return (
          <div key={questionIndex}>
            <div className={classes.questionDiv}>
              <div className={`${classes.sign}`}>
                <p className={classes.signNumber}>{questionIndex + 1}</p>
              </div>
              <p className={classes.question}>{el.title}</p>
            </div>
            <TextField
              value={
                this.props.managerSurveys[this.props.selectedManagerNoteIndex]
                  .fundamentalSurvey.questions[questionIndex].answer
              }
              onChange={this.onChangeFundamentalQuestionInput(questionIndex)}
              variant="outlined"
              fullWidth
              multiline
              placeholder="Écrire mes notes"
              classes={{ root: classes.underline }}
            />
          </div>
        );
      }
    );
  };

  displaySurvey = survey => {
    const { classes } = this.props;
    return survey.map((el, sectionIndex) => {
      const answers = el.questions.reduce((prev, curr, questionIndex) => {
        // display only if there was not an empty note
        if (curr.answer) {
          prev.push(
            <div key={questionIndex}>
              <div className={classes.questionDiv}>
                <div className={`${classes.sign}`}>
                  <p className={classes.signNumber}>{prev.length + 1}</p>
                </div>
                <p className={classes.question}>{curr.title}</p>
              </div>
              <TextField
                value={
                  this.props.managerSurveys[this.props.selectedManagerNoteIndex]
                    .survey[sectionIndex].questions[questionIndex].answer
                }
                onChange={this.onChangeQuestionInput(
                  sectionIndex,
                  questionIndex
                )}
                variant="outlined"
                fullWidth
                multiline
                placeholder="Écrire mes notes"
                classes={{ root: classes.underline }}
              />
            </div>
          );
        }
        return prev;
      }, []);

      if (answers.length > 0) {
        return (
          <div key={sectionIndex}>
            <SectionTitle
              text={`${romanize(sectionIndex + 1)}. ${el.sectionTitle}`}
            />
            {answers}
          </div>
        );
      }
      return null;
    });
  };

  render() {
    const { classes, isVisible, onClose } = this.props;

    return (
      <Dialog
        open={isVisible}
        onRendered={this.onRendered}
        onClose={this.handleClose(onClose)}
        classes={{ paper: classes.modal }}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
      >
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <IconButton
          className={`${classes.deleteButton} ${this.props.managerSurveys
            .length < 1 && classes.invisible}`}
          onClick={this.onDelete}
        >
          <DeleteIcon />
        </IconButton>

        <DialogTitle id="scroll-dialog-title" className={classes.title}>
          {this.props.managerSurveys.length < 1 &&
            `Écrivez votre première note !`}
          {this.props.managerSurveys.length > 0 && (
            <span>
              {`Mes notes (${this.props.selectedManagerNoteIndex + 1}/${
                this.props.managerSurveys.length
              }) - `}
              <span className={`${classes.accent}`}>
                {this.props.managerSurveys.length > 0 &&
                  this.formatDate(
                    this.props.managerSurveys[
                      this.props.selectedManagerNoteIndex
                    ].date
                  )}
              </span>
            </span>
          )}
        </DialogTitle>
        <div className={classes.saveButtonDiv}>
          {this.props.requesting ? (
            <Loader size={"45%"} />
          ) : (
            <div className={classes.actionsDiv}>
              <Button
                onClick={this.onSaveManagerSurvey}
                disabled={
                  this.props.requesting || this.props.managerSurveys.length < 1
                }
                variant="outlined"
                color="primary"
              >
                Sauvegarder mes modifications
              </Button>
            </div>
          )}
        </div>
        <div className={classes.bottomDiv}>
          <div className={classes.leftBorder}>
            <IconButton
              className={`${classes.chevronButton} ${!this.props
                .selectedManagerNoteIndex > 0 && classes.invisible}`}
              onClick={this.onPrevious}
            >
              <ChevronLeft />
            </IconButton>
          </div>
          <DialogContent className={classes.middleContent}>
            <DialogContentText className={classes.minDiv} />
            {this.props.managerSurveys.length < 1 ? (
              <LottieEmpty />
            ) : (
              <div className={classes.commentMainDiv}>
                <SectionTitle text="NOTES ADDITIONNELLES" />
                <TextField
                  value={
                    this.props.managerSurveys[
                      this.props.selectedManagerNoteIndex
                    ].additionalNotes || ""
                  }
                  variant="outlined"
                  onChange={this.onChangeAdditionalNotes}
                  fullWidth
                  multiline
                  placeholder="Écrire mes notes"
                  className={classes.additionalNotesInput}
                  classes={{ root: classes.underline }}
                />

                {this.props.managerSurveys[this.props.selectedManagerNoteIndex]
                  .fundamentalSurvey && (
                  <SectionTitle text="QUESTIONS FONDAMENTALES" />
                )}
                {this.displayFundamentalSurvey(
                  this.props.managerSurveys[this.props.selectedManagerNoteIndex]
                )}
                {this.displaySurvey(
                  this.props.managerSurveys[this.props.selectedManagerNoteIndex]
                    .survey
                )}
              </div>
            )}
            {/* <div className={classes.actionsButtonDiv}>
                <IconButton
                  classes={{ root: classes.deleteButton }}
                  className={classes.button}
                  aria-label="Delete"
                  onClick={this.onDelete(selectedSurvey._id)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
                <IconButton
                  classes={{ root: classes.editButton }}
                  className={classes.button}
                  aria-label="Edit"
                  onClick={this.onEdit(selectedSurvey)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </div> */}
            <Dialog
              open={this.state.open}
              onClose={this.closeDeleteModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Êtes-vous sûr de vouloir supprimer cette note ?"}
              </DialogTitle>
              <DialogContent />
              <DialogActions>
                <Button onClick={this.closeDeleteModal} color="primary">
                  Annuler
                </Button>
                <Button onClick={this.deleteSurvey} color="secondary">
                  Supprimer
                </Button>
              </DialogActions>
            </Dialog>
          </DialogContent>
          <div className={classes.rightBorder}>
            <IconButton
              className={`${classes.chevronButton} ${this.props
                .selectedManagerNoteIndex >=
                this.props.managerSurveys.length - 1 && classes.invisible}`}
              onClick={this.onNext}
            >
              <ChevronRight />
            </IconButton>
          </div>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const {
    userSelected,
    userComment,
    managerSurveys,
    managerSurvey,
    requesting,
    selectedManagerNoteIndex
  } = state.manager;
  const { userId } = state.client;
  return {
    userId,
    requesting,
    managerSurvey,
    managerSurveys: managerSurveys,
    userSelected,
    userComment,
    selectedManagerNoteIndex
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { changeField, modifyManagerSurveyRequest, deleteManagerSurveyRequest }
  )(NotesModal)
);
